// Import react.
import * as React from 'react';
// Import enumerations.
import {
	EndorsementSectionName,
} from '@app/enumerations';

interface IEndorsementContext {
	updateBackNavigationSection: (sectionName: EndorsementSectionName | undefined) => void;
	updateHeaderVisibility: (hideHeader: boolean) => void;
}

const EndorsementContext: React.Context<IEndorsementContext> = React.createContext<IEndorsementContext>({
	updateBackNavigationSection: (sectionName: EndorsementSectionName | undefined) => { },
	updateHeaderVisibility: (hideHeader: boolean) => { }
});

export default EndorsementContext;